import React from 'react';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import { Row } from '@buyside/components/base/Card/Card';

import { employerProfileVanityUrl, employerProfileUrl } from '@buyside/util/urlHelper';
const { introRequestStatuses } = require('buyside/util/constantsFromRails.json');

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply';
import ThumbsDown from '@assets/svgs/thumbs_down.svg';
import {
  MessageThreadItemFragment,
  UpdateIntroRequestStatusMutationFn
} from '@interfaces/graphql-typings';

import styles from './MessageCardStyles.scss';

interface CapIntroMessageButtonProps {
  employer:
    | NonNullable<
        NonNullable<MessageThreadItemFragment['sender']>['mostRecentEmployer']
      >['employer']
    | null
    | undefined;
  introRequest: MessageThreadItemFragment['introRequest'];
  updateIntroRequest: UpdateIntroRequestStatusMutationFn;
  readonly messageFromSystemUser: boolean;
}

export class CapIntroMessageButtons extends React.Component<
  CapIntroMessageButtonProps,
  { status: string | null }
> {
  constructor(props: CapIntroMessageButtonProps) {
    super(props);
    this.state = {
      status: null
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(status: string): () => void {
    const { updateIntroRequest, introRequest } = this.props;
    return (): void => {
      this.setState({
        status: status
      });

      if (introRequest?.id)
        updateIntroRequest({
          variables: {
            introRequestId: introRequest?.id,
            status: status
          }
        }).then((): void => {
          this.setState({
            status: null
          });
        });
    };
  }

  ReplyIcon(): React.ReactElement {
    return <FontAwesomeIcon icon={faReply} className={styles.fontAwesomeIcons} />;
  }

  render(): React.ReactElement {
    const { employer, messageFromSystemUser } = this.props;
    const { status } = this.state;

    const showViewFundProfileButton = !messageFromSystemUser;
    // Stacy Kim 5/15/19 - The inital request used to be sent by the "System User"
    // By doing this, we will ensure that the "Show Fund Profile" button does not appear twice
    // Probably should deprecate at some point, in a year or so

    return (
      <Row className={styles.capIntroRequestButtons}>
        <Button
          analyticsTag="open-reply-message"
          disabled={!!status}
          icon={this.ReplyIcon}
          onClick={this.handleClick(introRequestStatuses.accepted)}
          text="Reply"
          type={BUTTON_TYPES.MAJOR}
        />
        {showViewFundProfileButton && (
          <Button
            disabled={!!status}
            text="View Fund Profile"
            type={BUTTON_TYPES.PRIMARY}
            url={
              employer
                ? employer.employerProfile
                  ? employerProfileVanityUrl(employer.employerProfile.id)
                  : employerProfileUrl(employer.id)
                : ''
            }
          />
        )}
        <Button
          analyticsTag="ignore-request"
          disabled={!!status}
          icon={ThumbsDown}
          onClick={this.handleClick(introRequestStatuses.hidden)}
          text="Decline"
          type={BUTTON_TYPES.DANGER}
        />
      </Row>
    );
  }
}

export default CapIntroMessageButtons;
